import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faUsers, faShieldAlt, faFileAlt, faExternalLinkAlt, faInfoCircle, faSitemap } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
const Definition = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin:'2%',
        borderRadius:'10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faIdCard} className="me-2" />
            Ex-Serviceman Information
          </h3>
        </Container>
      </div>
      <Container className="py-5">
        <Row>
          {/* Definition Section */}
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(30,60,114,0.2)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faUsers} className="me-2" />
                  Definition of Armed Forces
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{color: '#495057', lineHeight: '1.8', fontSize: '1rem'}}>
                  The Armed Forces of the Union means the Army, Navy and Air Force of the Indian Union including the Armed Forces of the former Indian States, but excludes the persons who have served in Defence Security Corps, General Reserve Engineering Force, Lok Sahayak Sena and Para Military Forces (PMF).
                </p>
                <div className="p-3 mt-3" style={{background: 'linear-gradient(135deg, #e6e6fa 0%, #f0e6ff 100%)', borderRadius: '12px', borderLeft: '4px solid #1e3c72'}}>
                  <small className="d-block mb-2" style={{color: '#1e3c72', fontWeight: '600'}}>
                    <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                    Important Note
                  </small>
                  <p className="mb-0" style={{fontSize: '0.95rem', color: '#495057'}}>
                    Please remember, the ESM Identity Card is a prerequisite for availing the benefits of the welfare schemes instituted under the Armed Forces Flag Day Fund vide Govt of India / MoD SRO 7E dated 13 Apr 1993.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
          
          {/* Identity Card Section */}
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(22,160,133,0.2)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faIdCard} className="me-2" />
                  Issuing of Identity Card
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{color: '#495057', lineHeight: '1.8', fontSize: '1rem'}}>
                  The Identity Card to the retiring Armed Forces personnel is issued by the concerned ZSB / ZSWO where the retiring Defence Personnel propose to settle down after retirement as recorded in their discharge document(s). For this purpose, all the retiring defence personnel are required to call on concerned ZSB / ZSWO for registration and issue of Identity Card. At ZSB / ZSWO, particulars of the retiring defence personnel will be scrutinized and in case they qualify to the status of Ex-Servicemen, they will be asked to fill up in an Application Form and Identity Card will be issued to them. Application form for issue of ESM Identity Cards can be downloaded from the Link indicated below.
                </p>
                
                <a 
                  href="http://164.100.137.95/dsaw" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn mt-3 w-100"
                  style={{
                    background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '14px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(22,160,133,0.3)'
                  }}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                  Download Application Form
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
        
        {/* Registration Section */}
        <Row className="mt-4">
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(142,68,173,0.2)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faUsers} className="me-2" />
                  Ex-Serviceman Registration
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{color: '#495057', lineHeight: '1.8', fontSize: '1rem'}}>
                  All the retired Defence personnel are required to register themselves at the ZSB / ZSWO where they propose to settle down after retirement as recorded in their discharge documents. For this purpose, all retiring defence personnel are required to fill up their Registration Form in duplicate at respective Record Office at the time of their discharge. One copy of the duly filled Registration Form is forwarded by the Record Office to concerned ZSB / ZSWO by post and the second copy by hand through the retirees. Thereafter, the individuals are required to call on concerned ZSB / ZSWO along with three copies of stamp-size photographs, Discharge Certificate / PPO and other relevant Service Documents for registration of their names with the respective ZSBs. Application Form for applying for registration by Ex-Servicemen and widows will be provided by respective RSB / ZSB.
                </p>
                
                <a 
                  href="http://164.100.137.95/dsaw" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn mt-3 w-100"
                  style={{
                    background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '14px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(142,68,173,0.3)'
                  }}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                  Register as ESM
                </a>
              </CardBody>
            </Card>
          </Col>
          
          <Col lg={6} className="mb-4">
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(155,89,182,0.2)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #6a5acd 0%, #7e57c2 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
                  Ex-Central Armed Police Force
                </h4>
              </div>
              <CardBody className="p-4">
                <p style={{color: '#495057', lineHeight: '1.8', fontSize: '1rem'}}>
                  Ex-Central Armed Police Force personnel can also register through the dedicated portal. The registration process is streamlined for CAPF personnel to ensure quick and efficient processing.
                </p>
                <div className="p-3 mt-3" style={{background: 'linear-gradient(135deg, #8e6fa 0%, #c084fc 100%)', borderRadius: '12px', borderLeft: '4px solid #6a5acd'}}>
                  <small className="d-block mb-1" style={{color: '#6a5acd', fontWeight: '600'}}>
                    <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    Note
                  </small>
                  <p className="mb-0" style={{fontSize: '0.95rem', color: '#495057'}}>
                    Use Mera Parivar portal for CAPF registration and updates.
                  </p>
                </div>
                <a 
                  href="https://meraparivar.haryana.gov.in/UpdateXparamilitaryForces" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn mt-3 w-100"
                  style={{
                    background: 'linear-gradient(135deg, #6a5acd 0%, #7e57c2 100%)',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '14px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(155,89,182,0.3)'
                  }}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                  CAPF Registration Portal
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Definition;
